module.exports = __webpack_public_path__ + "img/facebook.e44d4dd6.svg";